import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
export function FromFunctionsRedirection() {
    const navigate = useNavigate();
    const redirectRoutes = () => {
        const location = window.location;
        if (location.pathname.startsWith("/_/")) {
            const newPath = location.pathname.slice(2); // Remove the leading '#'
            console.log(newPath);
            navigate(newPath, { replace: true }); // Use history.replace to update the URL without reloading
        }
        console.log(location.pathname);
    };

    useEffect(() => {
        redirectRoutes();
    });

    return <></>;
}